(function () {
  var POOL_SELECTOR = '.dbtfy-cart-upsell-extended-pool';
  var TARGET_SELECTOR = '.dbtfy-cart-upsell-extended-target';
  var ITEM_SELECTOR = '.dbtfy-cart-upsell-extended__item';
  var ADD_BUTTON_SELECTOR = '.dbtfy-cart-upsell-extended__add';
  var VARIANT_SELECT_SELECTOR = '.dbtfy-cart-upsell-extended__variants';
  var PRICE_CURRENT_SELECTOR = '.dbtfy-cart-upsell-extended__price-current';
  var PRICE_COMPARE_SELECTOR = '.dbtfy-cart-upsell-extended__price-compare';
  var IMAGE_SELECTOR = '.dbtfy-cart-upsell-extended__image';
  var LOADING_CLASS = 'is-loading';

  function getHeadingText() {
    return (window.themeVariables && themeVariables.strings && themeVariables.strings.cartUpsellExtendedHeading) || 'Complete your order';
  }

  function getCartProductHandles(cart) {
    var handles = {};
    (cart.items || []).forEach(function (item) {
      if (item.handle) handles[item.handle] = true;
    });
    return handles;
  }

  function renderUpsells(cart) {
    var targets = document.querySelectorAll(TARGET_SELECTOR);
    if (!targets.length) return;

    var pool = document.querySelector(POOL_SELECTOR);
    if (!pool) {
      targets.forEach(function (target) { target.innerHTML = ''; });
      return;
    }

    var cartHandles = getCartProductHandles(cart);
    var items = pool.querySelectorAll(ITEM_SELECTOR);
    var matches = [];

    items.forEach(function (item) {
      var productHandle = item.getAttribute('data-product-handle');
      if (cartHandles[productHandle]) return; // already in cart, don't offer it again

      var type = item.getAttribute('data-upsell-type');
      if (type === 'general') {
        matches.push(item);
      } else if (type === 'specific') {
        var triggerHandle = item.getAttribute('data-trigger-handle');
        if (cartHandles[triggerHandle]) matches.push(item);
      }
    });

    targets.forEach(function (target) {
      target.innerHTML = '';
      if (!matches.length) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'dbtfy-cart-upsell-extended drawer__inner-section';

      var customId = pool.getAttribute('data-custom-id');
      if (customId) wrapper.id = customId;

      var heading = document.createElement('p');
      heading.className = 'dbtfy-cart-upsell-extended__heading';
      heading.textContent = getHeadingText();
      wrapper.appendChild(heading);

      var list = document.createElement('div');
      list.className = 'dbtfy-cart-upsell-extended__list';
      matches.forEach(function (item) {
        list.appendChild(item.cloneNode(true));
      });
      wrapper.appendChild(list);

      target.appendChild(wrapper);
    });
  }

  function refreshCart() {
    if (window.theme && theme.ajaxCart && typeof theme.ajaxCart.update === 'function') {
      theme.ajaxCart.update();
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(ADD_BUTTON_SELECTOR);
    if (!button || !button.closest(TARGET_SELECTOR)) return;

    event.preventDefault();
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.classList.contains(LOADING_CLASS)) return;

    button.disabled = true;
    button.classList.add(LOADING_CLASS);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(refreshCart)
      .catch(refreshCart)
      .finally(function () {
        button.disabled = false;
        button.classList.remove(LOADING_CLASS);
      });
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest(VARIANT_SELECT_SELECTOR);
    if (!select || !select.closest(TARGET_SELECTOR)) return;

    var item = select.closest(ITEM_SELECTOR);
    if (!item) return;

    var button = item.querySelector(ADD_BUTTON_SELECTOR);
    if (button) button.setAttribute('data-variant-id', select.value);

    var selectedOption = select.options[select.selectedIndex];
    var priceEl = item.querySelector(PRICE_CURRENT_SELECTOR);
    if (priceEl && selectedOption.getAttribute('data-price')) {
      priceEl.textContent = selectedOption.getAttribute('data-price');
    }

    var comparePriceEl = item.querySelector(PRICE_COMPARE_SELECTOR);
    var comparePrice = selectedOption.getAttribute('data-compare-price');
    if (comparePriceEl) {
      if (comparePrice) {
        comparePriceEl.textContent = comparePrice;
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.hidden = true;
      }
    }

    var imageSrc = selectedOption.getAttribute('data-image');
    if (imageSrc) {
      var imageEl = item.querySelector(IMAGE_SELECTOR);
      if (imageEl) {
        imageEl.src = imageSrc;
        imageEl.removeAttribute('srcset');
      }
    }
  });

  document.addEventListener('theme:cart:loaded', function (event) {
    renderUpsells(event.detail.cart);
  });
  document.addEventListener('theme:cart:initially-loaded', function () {
    if (window.theme && theme.cart) renderUpsells(theme.cart);
  });
})();
